import React from 'react';

import { ErrorContext, ErrorContextValues } from '@smart-tv/contexts/error-context/error-context';

export const useDialog = (): ErrorContextValues => {
  const values = React.useContext(ErrorContext);

  return { ...values };
};

export default useDialog;
